import React, { useState } from 'react';
import Header from '@components/HomeHeader/HomeHeader';
import { useQuery } from '@hooks/query';
import CataLogue from './_components/catalogue/catalogue';
import UserAction from './_components/UserAction';
import Scientist from './scientist';
import Innovate from './innovate';

import './index.scss';

import { Provider, useSimpleContext } from '../applyView/_context';

const Preview = () => {
  const {
    state: {
      formType,
    },
  } = useSimpleContext((t) => [t.formType]);

  const [obFlag, setObFlag] = useState(0);

  const startOb = () => {
    setObFlag(obFlag + 1);
  };

  const renderUserAction = () => (
    <UserAction />
  );

  return (
    <div className="preview">
      <Header renderUserAction={renderUserAction} />
      <div className="preview-container">
        <CataLogue startObserver={obFlag} />
        {
          formType === 'scientist' ? (
            <Scientist startOb={startOb} />
          ) : (
            <Innovate startOb={startOb} />
          )
        }
      </div>
    </div>
  );
};

export default () => {
  const query = useQuery();
  const formType = query.get('formType');
  return (
    <Provider value={{
      formType,
    }}
    >
      <Preview />
    </Provider>
  );
};
